import { CreateVehicleCompanyDto, RowVehicleCompanyDto, UpdateVehicleCompanyDto } from "@/dtos"
import { Company, Vehicle, VehicleCompany } from "@/entities"
import { getVehicleCompanyRol } from "@/helpers/options";

export const formatVehicleCompanyDto = async (rowVehicleCompanyDto: RowVehicleCompanyDto, idVehicle: number, isCreate: boolean) => {
    const vehicleCompanyDto = {
        role: rowVehicleCompanyDto.company_role_id.toString(),
        vehicle: { id: idVehicle } as Vehicle,
        company: { id: rowVehicleCompanyDto.company_id } as Company
    }

    return (isCreate) ? vehicleCompanyDto as CreateVehicleCompanyDto : vehicleCompanyDto as UpdateVehicleCompanyDto
}

export const formatRowVehicleCompany = (vehicleCompanies: VehicleCompany[]): RowVehicleCompanyDto[] => {
    return vehicleCompanies.map((r) => {
        const row: RowVehicleCompanyDto = {
            id: r.id,
            vehicle_id: r.vehicle.id,
            company_id: r.company.id,
            company_name: r.company.name ?? '',
            company_role_id: parseInt(r.role),
            role_name: getVehicleCompanyRol(parseInt(r.role)).label,
            active: (r.is_active) ? 'Activo' : 'Inactivo',
            is_active: r.is_active,
        }
        return row;
    });
}